<template>
<Modal v-model="showModal" :mask-closable="false" width="500px">
  <div slot="header">导入灯杆信息</div>
  <div class="import-container">
    <Form ref="form" :label-width="100" class="import-form">
      <!-- <FormItem prop="areaId" :label="showLang('com.site')">
        <Select v-model="form.stationId">
          <Option v-for="(s, idx) in stations" :key="idx" :value="s.id">{{s.name}}</Option>
        </Select>
      </FormItem> -->
      <FormItem prop="lng" :label="showLang('import.choose.file')">
        <div style="display: flex">
          <div class="logo-upload">
            <input ref="fileInput" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" :disabled="loading" />
          </div>
        </div>
      </FormItem>
  </Form>
</div>
  <div slot="footer">
    <Button style="margin-right: 8px" @click="cancel">{{showLang('com.op.close')}}</Button>
    <Button type="success" style="margin-left: 8px;height: 40px;" :loading="loading" @click="ok">{{showLang('import.data')}}</Button>
  </div>
  <!-- <ModalSelectGroup v-model="showSelectModal" @newGroupSelected="newGroupSelected" /> -->
</Modal>
</template>
<script>
import { mapState,mapGetters } from 'vuex'
export default {
  name: 'ModalLampImportNew',
  components:{
  },
  model: {
    prop: 'value',
    event: 'showChanged'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default(){ return {};}
    },
    stations: {
      type: Array,
      default(){return [];}
    },
  },
  data () {
    return {
      showModal: this.value,
      // showSelectModal: false,
      loading: false,
      isAdd: false,
      form: {
        stationId: 0,
      },
    }
  },
  computed: {
    ...mapState('auth', ['appType']),
    ...mapGetters('auth', ['showLang']),
    ...mapState('cmd', ['windowOnResize']),
    ...mapState('common', ['powerBoxAlarmTypes', 'productCodes', 'deviceTypes', 'newLightTypes', 'smallTypes']),
    ...mapState('group', ['selectedDevices', 'selectedNode', 'selectedGroups']),
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
      if(newVal){
        this.isAdd = this.item.isAdd;
        this.$refs.fileInput.value = '';
        this.form.stationId = 0;
      }
    },
    showModal(val){
      this.$emit('showChanged', val);
    },
  },
  mounted: function(){
  },
  methods: {
    ok: async function () {
      // if(!this.form.stationId || this.form.stationId <= 0){
      //   this.$Message.warning(this.showLang('com.import.site.select'));
      //   return;
      // }
      if(this.$refs.fileInput.value == ''){
        this.$Message.warning(this.showLang('com.import.file.select'));
        return;
      }
      let formData = new FormData();
      formData.append("file", this.$refs.fileInput.files[0]);
      // formData.append("stationId", this.form.stationId);
      this.$axios.request({
        url: `//${this.domains.trans}/pole/config/ImportPoleData`,
        method: 'post',
        data: formData,
        responseType: 'json',
        myType: 'file'
      }).then(res => {
        if(res.code == 0){
          if(res.data.length > 0){
            this.$Modal.info({
              title: this.showLang('import.success.part'),
              content: res.data.map(p => `行号${p.row}:${p.message}`).join('<br/>')
            });
          }else{
            this.$Modal.info({
              title: this.showLang('import.result'),
              content: this.showLang('import.success.all'),
            });
          }
          this.showModal = false;
          this.$emit('saved', {});
          window.eventBus.$emit('poleChanged');
        }
      });
    },
    cancel () {
      this.showModal = false;
    },
  }
}
</script>
<style scoped>
.form-item-group{
  border: solid 1px rgba(129, 124, 124, 0.377);
  border-radius: 12px;
  margin-bottom: 15px;
}
.group-header{
  /* border: solid 1px blue; */
  background-color: rgba(221, 216, 216, 0.808);
  margin-bottom: 15px;
  height: 35px;
  border-radius: 12px 12px 0 0;
  line-height: 35px;
  font-weight: bold;
  padding: 0 10px;
}

.import-container{
  /* border: solid 1px red; */
  /* height: 100%; */
  display: flex;
}
.import-form{
  width: 350px;
  flex: none;
}
.import-data{
  width: 500px;
  flex: auto;
  margin-left: 35px;
}
.logo-upload{
  width: 100%;
  height:40px;
  border:solid 1px #dcdee2;
  cursor: pointer;
}
.logo-upload input{
  /* visibility: hidden; */
  width: 100%;
}
.logo-upload button{
  /* visibility: hidden; */
  width: 100%;
  height: 40px;
}
</style>